var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-wrap",attrs:{"data-app":"true"}},[_c('Header-menu'),_c('div',{staticClass:"wrapper"},[_c('User-menu'),_c('KnowledgeCheckDetailWrap')],1),_c('FooterBlock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }